"use client";

import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
} from "@ionic/react";
import { AttachMoney, Receipt, PersonAdd, Close, Person, Search, Visibility, Description } from "@mui/icons-material";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Card,
  CardContent,
  Snackbar,
  Alert,
  Divider,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Avatar,
  IconButton,
  InputAdornment,
  Autocomplete,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import React, { useState, useEffect } from "react";
 
import { useHistory } from "react-router-dom";
import { createCustomer, searchCustomers, searchCustomersLive } from "../../../api/customers/customers";
import { createCustomerOrder_giftCard, getCustomerBanks, getExternalProcessorsAPI, verifyBankAccount } from "../../../api/orders/orders";
import { banks } from "../../../api/banks";
import { ReceiptIcon, CheckCircleIcon } from "lucide-react";
import CancelIcon from '@mui/icons-material/Cancel';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { baseUrl, config, requestID } from "../../../common/utils";
import axios from "axios";
import { MenuButton } from "../../../components/Menu";

// Helper function to safely convert to number
const toNumber = (value: any): number => {
  if (value === null || value === undefined || value === '') return 0;
  const num = Number(value);
  return isNaN(num) ? 0 : num;
};

// Helper function to safely check if a string is empty
const isStringEmpty = (value: any): boolean => {
  if (value === null || value === undefined) return true;
  if (typeof value !== 'string') return true;
  return value.trim() === '';
};

const initialFormData = {
  cardAmount: "",
  cardUnit: "",
  loadType: "",
  cardRate: "",
  cardCode: "",
  customerName: "",
  customerPhone: "",
  customerEmail: "",
  processorType: "",
  externalProcessor: "",
  nairaRate: "",
  internalRate: "",
  username: "",
  sellingPrice: "",
  customeraltEmail: "",
  customer_bank_code: "",
  customer_account_number: "",
  customer_account_name: "",
  giftcardType: "", // Added gift card type field
};

const PosPage_Gift_card: React.FC = () => {
    const history = useHistory();
    const [formData, setFormData] = useState(initialFormData);
    const [transactionStartTime, setTransactionStartTime] = useState<Date | null>(new Date());
    const [transactionEndTime, setTransactionEndTime] = useState<Date | null>(new Date());
    const [uploadedFile, setUploadedFile] = useState(null);
    const [jobStatsFile, setJobStatsFile] = useState(null);
    const [commission, setCommission] = useState(0);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">("success");

    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [showCustomerDialog, setShowCustomerDialog] = useState(false);
    const [customerSearchQuery, setCustomerSearchQuery] = useState("");
    const [searchedCustomers, setSearchedCustomers] = useState([]);
    const [newCustomer, setNewCustomer] = useState({
        firstName: "",
        middleName: "",
        lastName: "",
        phone: "",
        email: "",
        grade: "A",
        altEmail: "",
      });
    const [loading, setLoading] = useState({
        customers: false,
        grades: false,
        products: false,
        externalProcessors: false,
        giftcardTypes: false,
    });
    const [externalProcessors, setExternalProcessors] = useState<{ id: string; name: string; currency: string; type: string }[]>([]);
    const [giftcardTypes, setGiftcardTypes] = useState<{ id: string; name: string; symbol: string; rateBoxLabel: string }[]>([]); // Updated based on table structure
    const [processingOrder, setProcessingOrder] = useState(false);
    const [rmbValue, setRmbValue] = useState(0);
    const [cardValue, setCardValue] = useState(0);
    const [unitPrice, setUnitPrice] = useState(0);
    const [costPrice, setCostPrice] = useState(0);
    const [verifyingAccount, setVerifyingAccount] = useState(false);
    const [showSummaryDialog, setShowSummaryDialog] = useState(false);
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [customerBanks, setCustomerBanks] = useState([]);
    const [selectedBankId, setSelectedBankId] = useState("");
    const [allCustomers, setAllCustomers] = useState([]);
    const [customersFetched, setCustomersFetched] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);
    const [formErrors, setFormErrors] = useState<string[]>([]);

    // Get selected processor type - Returns USD or CHINESE for external processors
    const getSelectedProcessorType = () => {
        if (formData.processorType === "INTERNAL") return "INTERNAL";
        if (formData.processorType === "EXTERNAL" && formData.externalProcessor) {
            const processor = externalProcessors.find(p => p.name === formData.externalProcessor);
            return processor?.type || "USD"; // Default to USD if type not found
        }
        return "USD"; // Default fallback
    };

    const processorType = getSelectedProcessorType();

    // Validation function to check if all required fields are filled
    const validateForm = () => {
        const errors: string[] = [];
        
        // Customer validation
        if (!selectedCustomer) {
            errors.push("Please select a customer");
        }
        
        // Basic card info validation
        if (!formData.cardAmount || toNumber(formData.cardAmount) <= 0) {
            errors.push("Card amount is required and must be greater than 0");
        }
        if (!formData.cardUnit || toNumber(formData.cardUnit) <= 0) {
            errors.push("Card unit is required and must be greater than 0");
        }
        if (!formData.loadType) {
            errors.push("Load type is required");
        }
        if (!formData.giftcardType) {
            errors.push("Gift card type is required");
        }
        
        // Card code validation
        if (isStringEmpty(formData.cardCode)) {
            errors.push("Card code is required");
        }
        
        // Processor type validation
        if (!formData.processorType) {
            errors.push("Processor type is required");
        }
        
        // Internal processor validation
        if (formData.processorType === 'INTERNAL') {
            if (!formData.internalRate || toNumber(formData.internalRate) <= 0) {
                errors.push("Internal rate is required for internal processors");
            }
        }
        
        // External processor validation
        if (formData.processorType === 'EXTERNAL') {
            if (!formData.externalProcessor) {
                errors.push("External processor is required");
            }
            if (!formData.cardRate || toNumber(formData.cardRate) <= 0) {
                errors.push("Card rate is required for external processors");
            }
            
            // Additional validation for CHINESE processors
            const processorTypeCategory = getSelectedProcessorType();
            if (processorTypeCategory === 'CHINESE') {
                if (!formData.nairaRate || toNumber(formData.nairaRate) <= 0) {
                    errors.push("Naira rate is required for Chinese processors");
                }
            }
        }
        
        // Customer bank info validation
        if (!formData.customer_bank_code) {
            errors.push("Customer bank is required");
        }
        if (!formData.customer_account_number || formData.customer_account_number.length !== 10) {
            errors.push("Customer account number must be 10 digits");
        }
        if (isStringEmpty(formData.customer_account_name)) {
            errors.push("Customer account name is required");
        }
        
        // Selling price validation
        if (!formData.sellingPrice || toNumber(formData.sellingPrice) <= 0) {
            errors.push("Selling price is required and must be greater than 0");
        }
        
        // Transaction time validation
        if (!transactionStartTime) {
            errors.push("Transaction start time is required");
        }
        
        // Job stats file validation
        // if (!jobStatsFile) {
        //     errors.push("Evidence of Job Starts file is required");
        // }
        
        // Commission validation (must be at least ₦100)
        if (commission < 100) {
            errors.push("Commission must be at least ₦100");
        }
        
        setFormErrors(errors);
        return errors.length === 0;
    };

    // Update form validation when dependencies change
    useEffect(() => {
        setIsFormValid(validateForm());
    }, [formData, selectedCustomer, transactionStartTime, commission, externalProcessors, jobStatsFile]);

    // Fetch external processors from API
    const fetchExternalProcessors = async () => {
        setLoading(prev => ({ ...prev, externalProcessors: true }));
        try {
            const response = await getExternalProcessorsAPI();
            setExternalProcessors(response.data);
            console.log("Fetched external processors:", response.data);
        } catch (error) {
            console.error("Error fetching external processors:", error);
            setSnackbarMessage("Failed to load external processors.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
            setExternalProcessors([]);
        } finally {
            setLoading(prev => ({ ...prev, externalProcessors: false }));
        }
    };

    // Fetch gift card types from API
    const fetchGiftcardTypes = async () => {
        setLoading(prev => ({ ...prev, giftcardTypes: true }));
        try {
            const response = await getGiftcardTypesAPI();
            console.log("Fetched gift card types:", response);
            // Based on the table structure, we expect an array of objects with id, name, symbol
            if (Array.isArray(response)) {
                setGiftcardTypes(response);
            } else if (response.data && Array.isArray(response.data)) {
                setGiftcardTypes(response.data);
            } else {
                // If API structure is different, adjust accordingly
                console.log("Unexpected API response structure:", response);
            }
        } catch (error) {
            console.error("Error fetching gift card types:", error);
            setSnackbarMessage("Failed to load gift card types.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
            setGiftcardTypes([]);
        } finally {
            setLoading(prev => ({ ...prev, giftcardTypes: false }));
        }
    };

    // Fetch external processors and gift card types on component mount
    React.useEffect(() => {
        fetchExternalProcessors();
        fetchGiftcardTypes();
    }, []);

    const fetchCustomerBanks = async (customerId) => {
        if (!customerId) return [];
        try {
            const res = await getCustomerBanks(customerId);
            if (res.status) {
                return res.data.data;
            } else {
                setSnackbarMessage(res.message || "No saved banks found for this customer.");
                setSnackbarSeverity("warning");
                setSnackbarOpen(true);
            }
        } catch (error) {
            console.error("Error fetching customer banks:", error);
            setSnackbarMessage("An error occurred while fetching customer banks.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        }
        return [];
    };

    React.useEffect(() => {
        const verifyAccount = async () => {
            if (formData.customer_bank_code && formData.customer_account_number.length === 10) {
                setVerifyingAccount(true);
                try {
                    const res = await verifyBankAccount(formData.customer_account_number, formData.customer_bank_code);

                    if (res) {
                        // Ensure the response is a string before setting it
                        setFormData(prev => ({ ...prev, customer_account_name: String(res) }));
                    } else {
                        setSnackbarMessage(res?.message || "Could not verify account name.");
                        setSnackbarSeverity("error");
                        setSnackbarOpen(true);
                        setFormData(prev => ({ ...prev, customer_account_name: "no name" }));
                    }
                } catch (error) {
                    console.error("Error verifying account:", error);
                    setSnackbarMessage("An error occurred while verifying the account.");
                    setSnackbarSeverity("error");
                    setSnackbarOpen(true);
                    setFormData(prev => ({ ...prev, customer_account_name: "" }));
                } finally {
                    setVerifyingAccount(false);
                }
            }
        };
        verifyAccount();
    }, [formData.customer_bank_code, formData.customer_account_number]);

    // Update RMB value based on processor type - Only for CHINESE external processors
    React.useEffect(() => {
        const amount = toNumber(formData.cardAmount);
        const cardRate = toNumber(formData.cardRate);
        const cardUnit = toNumber(formData.cardUnit);


        if (formData.processorType === "EXTERNAL" && processorType === "CHINESE") {
            setRmbValue(amount * cardRate  * cardUnit);
        } else {
            setRmbValue(0);
        }
    }, [formData.cardAmount, formData.cardRate, formData.processorType, processorType]);

    React.useEffect(() => {
        const calculatePrices = () => {
            const amount = toNumber(formData.cardAmount);
            const unit = toNumber(formData.cardUnit);
            const cardRate = toNumber(formData.cardRate);
            const nairaRate = toNumber(formData.nairaRate);
            const internalRate = toNumber(formData.internalRate);

            let newCostPrice = 0;
            let newUnitPrice = 0;

            if (formData.processorType === "INTERNAL") {
                newCostPrice = (amount * unit) * internalRate;
                newUnitPrice = amount * internalRate;
            } else if (formData.processorType === "EXTERNAL") {
                if (processorType === "CHINESE") {
                    newCostPrice = (amount * unit) * cardRate * nairaRate;
                    newUnitPrice = amount * cardRate * nairaRate;
                } else {
                    newCostPrice = (amount * unit) * cardRate;
                    newUnitPrice = amount * cardRate;
                }
            }
            
            setCostPrice(newCostPrice);
            setUnitPrice(newUnitPrice);

            const selling = toNumber(formData.sellingPrice);
            setCommission(newCostPrice - selling);
        };

        calculatePrices();
    }, [formData, cardValue, processorType]);

    React.useEffect(() => {
        const amount = toNumber(formData.cardAmount);
        const unit = toNumber(formData.cardUnit);
        setCardValue(amount * unit);
    }, [formData.cardAmount, formData.cardUnit]);

    const fetchCustomers = async () => {
        try {
            setLoading((prev) => ({ ...prev, customers: true }));
            const response = await searchCustomersLive();
            console.log("Fetched customers:", response.data);
            setAllCustomers(response.data);
            setCustomersFetched(true);
        } catch (error) {
            console.error("Error searching customers:", error);
            setSnackbarMessage("Failed to search customers.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
        } finally {
            setLoading((prev) => ({ ...prev, customers: false }));
        }
    };

    const handleAddCustomer = async () => {
        setLoading(prev => ({...prev, customers: true}));
        console.log("Adding new customer:", newCustomer);
        try {
          const response = await createCustomer(newCustomer);
          
          // Refresh the customers list
          await fetchCustomers();
          
          // Search for the newly added customer to get full data with ID
          try {
            const searchResult = await searchCustomersLive();
            const customers = searchResult.data || [];
            
            // Find the newly added customer by phone or email
            const newCustomerAdded = customers.find(customer => 
              customer.phone === newCustomer.phone || 
              customer.email === newCustomer.email ||
              customer.altEmail === newCustomer.altEmail
            );
            
            if (newCustomerAdded) {
              setSelectedCustomer(newCustomerAdded);
              
              // Update form data with the new customer's information
              setFormData(prev => ({
                ...prev,
                customerName: `${newCustomerAdded.firstName} ${newCustomerAdded.lastName}`,
                customerPhone: newCustomerAdded.phone,
                customerEmail: newCustomerAdded.uname || newCustomerAdded.email,
                customeraltEmail: newCustomerAdded.altEmail,
                username: newCustomerAdded.uname || '',
              }));
              
              // Also fetch the customer's banks if available
              if (newCustomerAdded.user_id) {
                const banks = await fetchCustomerBanks(newCustomerAdded.user_id);
                setCustomerBanks(banks);
              }
            } else {
              // Fallback to the response data if not found in search
              setSelectedCustomer(response.data);
              setFormData(prev => ({
                ...prev,
                customerName: `${response.data.firstName} ${response.data.lastName}`,
                customerPhone: response.data.phone,
                customerEmail: response.data.uname || response.data.email,
                customeraltEmail: response.data.altEmail,
                username: response.data.uname || '',
              }));
            }
          } catch (searchError) {
            console.error("Error searching for new customer:", searchError);
            // Fallback to response data
            setSelectedCustomer(response.data);
            setFormData(prev => ({
              ...prev,
              customerName: `${response.data.firstName} ${response.data.lastName}`,
              customerPhone: response.data.phone,
              customerEmail: response.data.uname || response.data.email,
              customeraltEmail: response.data.altEmail,
              username: response.data.uname || '',
            }));
          }
          
          setShowCustomerDialog(false);
          setNewCustomer({
            firstName: "",
            middleName: "",
            lastName: "",
            phone: "",
            email: "",
            grade: "A",
            altEmail: "",
          });
          
          setCustomerSearchQuery("");
          setSnackbarMessage("Customer added and selected successfully!");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
        } catch (error) {
          console.error("Error creating customer:", error);
          const errorMessage =
            error.response?.data?.message ||
            "Failed to add customer. Please check inputs.";
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        } finally {
          setLoading(prev => ({...prev, customers: false}));
        }
      };

    React.useEffect(() => {
        const loadBanks = async () => {
          console.log("Selected customer changed:", selectedCustomer);
            if (selectedCustomer) {
                setFormData(prev => ({
                    ...prev,
                    customerName: `${selectedCustomer.firstName} ${selectedCustomer.lastName}`,
                    customerPhone: selectedCustomer.phone,
                    customerEmail: selectedCustomer.uname,
                    customeraltEmail: selectedCustomer.altEmail,
                }));
                const banks = await fetchCustomerBanks(selectedCustomer.user_id);
                setCustomerBanks(banks);
                setSelectedBankId(""); // Reset selected bank when customer changes
            } else {
                setFormData(prev => ({
                    ...prev,
                    customerName: '',
                    customerPhone: '',
                    customerEmail: '',
                    customeraltEmail: '',
                    customer_bank_code: '',
                    customer_account_number: '',
                    customer_account_name: '',
                }));
                setCustomerBanks([]);
                setSelectedBankId("");
            }
        };
        loadBanks();
    }, [selectedCustomer]);

    React.useEffect(() => {
        if (selectedBankId) {
            const selectedBank = customerBanks?.find(bank => bank.id === selectedBankId);
            if (selectedBank) {
                setFormData(prev => ({
                    ...prev,
                    customer_bank_code: selectedBank.customer_bank_code,
                    customer_account_number: selectedBank.customer_account_number,
                    customer_account_name: String(selectedBank.customer_account_name || ''),
                }));
            }
        }
    }, [selectedBankId, customerBanks]);
  
    const handleChange = (field: string, value: any) => {
      setFormData({ ...formData, [field]: value });
    };


      const getGiftcardTypesAPI = async () => {
    const data = {
        requestID: requestID(),
    };
    try {
        const response = await axios.post(
            baseUrl() + "giftcard_currencys/getAll",
            data,
            config
        );
        console.log({ response })
        return response.data

    } catch (error: any) {
        return error
    }
}

    const handleCreateOrder = () => {
        if (!selectedCustomer) {
            setSnackbarMessage("Please select a customer before submitting.");
            setSnackbarSeverity("error");
            setSnackbarOpen(true);
            return;
        }

        // Debug: Check what processor type will be sent
        const processorTypeCategory = getSelectedProcessorType();
        console.log("=== DEBUG PROCESSOR TYPE ===");
        console.log("Form Processor Type:", formData.processorType);
        console.log("External Processor:", formData.externalProcessor);
        console.log("Processor Type Category to send:", processorTypeCategory);
        console.log("External Processors available:", externalProcessors);
        
        if (formData.processorType === "EXTERNAL" && formData.externalProcessor) {
            const selectedProc = externalProcessors.find(p => p.name === formData.externalProcessor);
            console.log("Selected Processor Details:", selectedProc);
        }

        setShowSummaryDialog(true);
    }
  
    const executeCreateOrder = async () => {
        setProcessingOrder(true);
        setShowConfirmDialog(false);

        const processorTypeCategory = getSelectedProcessorType();
        
        console.log("Sending processorTypeCategory:", processorTypeCategory);
        
        const saleData = new FormData();
        saleData.append("cardAmount", formData.cardAmount);
        saleData.append("cardUnit", formData.cardUnit);
        saleData.append("cardValue", cardValue.toString());
        saleData.append("unitPrice", unitPrice.toString());
        saleData.append("loadType", formData.loadType);
        saleData.append("cardRate", formData.cardRate);
        saleData.append("product_face_code", formData.cardCode);
        saleData.append("customerName", formData.customerName);
        saleData.append("customerPhone", formData.customerPhone);
        saleData.append("customerEmail", formData.customerEmail);
        saleData.append("processorType", formData.processorType);
        saleData.append("externalProcessor", formData.externalProcessor);
        saleData.append("nairaRate", formData.nairaRate);
        saleData.append("transactionStartTime", transactionStartTime.toISOString());
        saleData.append("giftcardType", formData.giftcardType); // Added gift card type

        saleData.append("internalRate", formData.internalRate);
        saleData.append("username", formData.customeraltEmail);
        saleData.append("sellingPrice", formData.sellingPrice);
        saleData.append("processor_category", processorTypeCategory); // This will be USD or CHINESE
        saleData.append("costPrice", costPrice.toString());
        saleData.append("customer_id", selectedCustomer?.user_id || "");
        saleData.append("customer_bank_code", formData.customer_bank_code);
        saleData.append("customer_account_number", formData.customer_account_number);
        saleData.append("customer_account_name", String(formData.customer_account_name || ''));
        if (uploadedFile) {
            saleData.append("file", uploadedFile);
        }
        if (jobStatsFile) {
            saleData.append("job_start_file", jobStatsFile);
        }
    
        try {
          const res = await createCustomerOrder_giftCard(Object.fromEntries(saleData.entries()));
          console.log("Order created successfully:", res);
          console.log("Processor Type Category sent:", processorTypeCategory);
          console.log("Gift Card Type sent:", formData.giftcardType);

          setSnackbarMessage("Order created successfully!");
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
          
          console.log("Navigating to receipt page with customer:", selectedCustomer);

          history.push('/folder/pending_raise_receipt_giftcard_crypto/move', { customer: selectedCustomer });

          setFormData(initialFormData);
          setSelectedCustomer(null);
          setUploadedFile(null);
          setJobStatsFile(null);
          setShowSummaryDialog(false);
        } catch (error) {
          console.error("Error creating order:", error);
          const errorMessage =
            error.response?.data?.message ||
            "Failed to create order. Please try again.";
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        } finally {
          setProcessingOrder(false);
        }
      };
  
    const formatWithCommas = (num: string | number) => {
        if (!num) return "";
        const cleanNum = String(num).replace(/,/g, '');
        return Number(cleanNum).toLocaleString("en-NG");
    };

    const handleSnackbarClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
      if (reason === 'clickaway') {
        return;
      }
      setSnackbarOpen(false);
    };
    return (
      <IonPage className="pushDown">
        <IonHeader>
          <IonToolbar>
            <MenuButton /> {/* This adds the hamburger icon */}
            <IonTitle>Gift Card Sales Posting</IonTitle>
          </IonToolbar>
        </IonHeader>
      <Box sx={{ p: 2, bgcolor: 'background.paper', borderBottom: '1px solid #e0e0e0' }}>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
          <Autocomplete
            sx={{ flexGrow: 1 }}
            options={allCustomers || []}
            getOptionLabel={(option) => 
              `${option?.firstName || ''} ${option?.lastName || ''} ${option?.phone ? `(${option.phone})` : ''}`
            }
            value={selectedCustomer}
            onOpen={() => {
              if (!customersFetched) {
                fetchCustomers();
              }
            }}
            onChange={(event, newValue) => {
              setSelectedCustomer(newValue);
            }}
            loading={loading.customers}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search for a customer"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading.customers ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
          <Button
            variant="contained"
            startIcon={<PersonAdd />}
            onClick={() => setShowCustomerDialog(true)}
            sx={{ height: '56px' }}
          >
            New
          </Button>
        </Box>
      </Box>
        <IonContent>
          <Box sx={{ 
            height: { xs: "auto", md: "100vh" }, 
            display: "flex", 
            flexDirection: { xs: "column", md: "row" },
            bgcolor: "#f5f7fa" 
          }}>
            {/* Form Panel */}
            <Box sx={{ width: { xs: "100%", md: "70%" }, p: 1, overflowY: { xs: "visible", md: "auto" } }}>
              <Paper sx={{ p: 1, borderRadius: 3 }}>
               
                <Grid container spacing={3}>

                  <Grid item xs={12}>
                    <Divider sx={{ my: 2 }}><Chip label="CUSTOMER INFO" /></Divider>
                  </Grid>
  
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Customer Email (Optional)"
                      type="email"
                      value={formData.customeraltEmail}
                      onChange={(e) => handleChange("customerEmail", e.target.value)}
                      disabled={!!selectedCustomer}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Username  (Optional)"
                      value={formData.customerEmail}
                      onChange={(e) => handleChange("username", e.target.value)}
                      disabled={!!selectedCustomer}
                    />
                  </Grid>

                  <Grid item xs={12}><Divider sx={{ my: 2 }}><Chip label="CUSTOMER BANK INFO" /></Divider></Grid>
                   <Grid item xs={12}>
                        <FormControl fullWidth disabled={!selectedCustomer || customerBanks?.length === 0}>
                            <InputLabel>Select Saved Bank Account</InputLabel>
                            <Select
                                value={selectedBankId}
                                label="Select Saved Bank Account"
                                onChange={(e) => setSelectedBankId(e.target.value as string)}
                            >
                                <MenuItem value=""><em>-- Select a bank --</em></MenuItem>
                                {customerBanks?.map((bank) => (
                                    <MenuItem key={bank.id} value={bank.id}>
                                        {`${bank.customer_account_name} - ${bank.customer_account_number}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth disabled={!!selectedBankId}>
                      <InputLabel>Customer Bank Name</InputLabel>
                      <Select
                        value={formData.customer_bank_code}
                        label="Customer Bank Name"
                        onChange={(e) => handleChange("customer_bank_code", e.target.value)}
                      >
                        {banks.map((bank) => (
                          <MenuItem key={bank.code} value={bank.code}>
                            {bank.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Customer Account Number"
                      type="number"
                      onWheel={(e) => (e.target as HTMLInputElement).blur()} 
                       sx={{
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    }
  }}
                      value={formData.customer_account_number}
                      onChange={(e) => handleChange("customer_account_number", e.target.value)}
                      disabled={!!selectedBankId}
                      InputLabelProps={{ shrink: !!formData.customer_account_number }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Customer Account Name"
                      value={formData.customer_account_name}
                      disabled
                      InputProps={{
                        endAdornment: verifyingAccount && (
                          <InputAdornment position="end">
                            <CircularProgress size={20} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}><Divider sx={{ my: 2 }}><Chip label="CARD INFO. PROCESSOR & RATES" /></Divider></Grid>
                  
                  {/* Card Details - ALWAYS SHOW THESE */}
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Card Amount"
                      type="number"
                      onWheel={(e) => (e.target as HTMLInputElement).blur()} 

                      
                       sx={{
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    }
  }}
                      value={formData.cardAmount}
                      onChange={(e) => handleChange("cardAmount", e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Card Unit"
                      
                      type="number"
                      onWheel={(e) => (e.target as HTMLInputElement).blur()} 
                       sx={{
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    }
  }}
                      value={formData.cardUnit}
                      onChange={(e) => handleChange("cardUnit", e.target.value)}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Card Value"
                      type="number"
                      onWheel={(e) => (e.target as HTMLInputElement).blur()} 
                       sx={{
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    }
  }}
                      value={cardValue}
                      disabled
                    />
                  </Grid>

                  {/* Gift Card Type Selection - ADDED BETWEEN CARD AMOUNT AND LOAD TYPE */}
                  <Grid item xs={12} md={3}>
                    <FormControl fullWidth>
                      <InputLabel>Gift Card Type</InputLabel>
                      <Select
                        value={formData.giftcardType}
                        label="Gift Card Type"
                        onChange={(e) => handleChange("giftcardType", e.target.value)}
                        disabled={loading.giftcardTypes}
                      >
                        <MenuItem value="">
                          <em>-- Select Gift Card Type --</em>
                        </MenuItem>
                        {giftcardTypes?.map((type) => (
                          <MenuItem key={type.id} value={type.rateBoxLabel}>
                            {type.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {loading.giftcardTypes && (
                      <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                        <CircularProgress size={16} />
                        <Typography variant="body2" sx={{ ml: 1 }}>
                          Loading gift card types...
                        </Typography>
                      </Box>
                    )}
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                      <InputLabel>Load Type</InputLabel>
                      <Select
                        value={formData.loadType}
                        label="Load Type"
                        onChange={(e) => handleChange("loadType", e.target.value)}
                      >
                        <MenuItem value="FAST">Fast</MenuItem>
                        <MenuItem value="SLOW">Slow</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Card Code"
                      value={formData.cardCode}
                      onChange={(e) => handleChange("cardCode", e.target.value)}
                      placeholder="Enter card code"
                      multiline
                      rows={3}
                    />
                  </Grid>

                  {/* Processor Type Selection */}
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel>Processor Type</InputLabel>
                      <Select
                        value={formData.processorType}
                        label="Processor Type"
                        onChange={(e) => handleChange("processorType", e.target.value)}
                      >
                        <MenuItem value="INTERNAL">Internal</MenuItem>
                        <MenuItem value="EXTERNAL">External</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* INTERNAL PROCESSOR: Show Naira Rate */}
                  {formData.processorType === 'INTERNAL' && (
                    <Grid item xs={12} md={6}>
                        <TextField
                          label="Internal Rate"
                          type="number"
                          fullWidth
                          onWheel={(e) => (e.target as HTMLInputElement).blur()} 
                          sx={{
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    }
  }}
                          value={formData.internalRate}
                          onChange={(e) => handleChange("internalRate", e.target.value)}
                        />
                    </Grid>
                  )}

                  {/* EXTERNAL PROCESSOR: Show External Processor Selection */}
                  {formData.processorType === 'EXTERNAL' && (
                    <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <InputLabel>External Processor</InputLabel>
                            <Select
                                value={formData.externalProcessor}
                                label="External Processor"
                                onChange={(e) => handleChange("externalProcessor", e.target.value)}
                                disabled={loading.externalProcessors}
                            >
                                <MenuItem value="">
                                    <em>-- Select External Processor --</em>
                                </MenuItem>
                                {externalProcessors?.map((processor) => (
                                    <MenuItem key={processor.id} value={processor.name}>
                                        {processor.name} ({processor.type})
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {loading.externalProcessors && (
                            <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                <CircularProgress size={16} />
                                <Typography variant="body2" sx={{ ml: 1 }}>
                                    Loading processors...
                                </Typography>
                            </Box>
                        )}
                    </Grid>
                  )}

                  {/* EXTERNAL CHINESE: Show Card Rate, RMB Value, and Naira Rate */}
                  {formData.processorType === 'EXTERNAL' && processorType === "CHINESE" && (
                    <>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Card Rate"
                           type="number"
                           onWheel={(e) => (e.target as HTMLInputElement).blur()} 
                            sx={{
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    }
  }}
                          value={formData.cardRate}
                          onChange={(e) => handleChange("cardRate", e.target.value)}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="RMB Value"
                          type="number"
                          onWheel={(e) => (e.target as HTMLInputElement).blur()} 
                          value={rmbValue.toFixed(2)}
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Naira Rate"
                             type="number"
                             onWheel={(e) => (e.target as HTMLInputElement).blur()} 
                              sx={{
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    }
  }}
                            value={formData.nairaRate}
                            onChange={(e) => handleChange("nairaRate", e.target.value)}
                        />
                      </Grid>
                    </>
                  )}

                  {/* EXTERNAL USD: Show Card Rate Only */}
                  {formData.processorType === 'EXTERNAL' && processorType === "USD" && (
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Card Rate"
                            type="number"
                            onWheel={(e) => (e.target as HTMLInputElement).blur()} 
                             sx={{
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    }
  }}
                            value={formData.cardRate}
                            onChange={(e) => handleChange("cardRate", e.target.value)}
                        />
                    </Grid>
                  )}
                  
                  <Grid item xs={12}><Divider sx={{ my: 2 }}><Chip label="SALES & UPLOAD" /></Divider></Grid>

                 <Grid item xs={12} md={6}>
                    <TextField
                        fullWidth
                        label="Selling Price"
                        type="number"
                        onWheel={(e) => (e.target as HTMLInputElement).blur()}  
                         sx={{
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },height: "56px"
  }}
                        value={formData.sellingPrice}
                        onChange={(e) => handleChange("sellingPrice", e.target.value)}
                        InputProps={{
                        startAdornment: <InputAdornment position="start">₦</InputAdornment>,
                        }}
                        
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                <Button
                    variant="outlined"
                    component="label"
                    fullWidth
                    sx={{ height: "56px" }}
                >
                    Upload Evidence of Manual Payments (Optional)
                    <input
                    type="file"
                    hidden
                    onChange={(e) => setUploadedFile(e.target.files[0])}
                    />
                </Button>
                {uploadedFile && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                    {uploadedFile.name}
                    </Typography>
                )}
                </Grid>
             

                <Grid item xs={12}><Divider sx={{ my: 2 }}><Chip label="TRANSACTION TIME" /></Divider></Grid>
                <Grid item xs={12} md={6}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DateTimePicker
                      renderInput={(props) => <TextField {...props} fullWidth />}
                      label="Transaction Start Time"
                      value={transactionStartTime}
                      onChange={(newValue) => setTransactionStartTime(newValue)}
                    />
                  </LocalizationProvider>
                </Grid>
                   <Grid item xs={12} md={6}>
                <Button
                    variant="outlined"
                    component="label"
                    fullWidth
                    sx={{ height: "56px" }}
                >
                    Upload Evidence of Job Starts *
                    <input
                    type="file"
                    hidden
                    onChange={(e) => setJobStatsFile(e.target.files[0])}
                    />
                </Button>
                {jobStatsFile && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                    {jobStatsFile.name}
                    </Typography>
                )}
                </Grid>
                </Grid>
              </Paper>
            </Box>
  
            {/* Summary Panel */}
            <Box sx={{ 
              width: { xs: "100%", md: "30%" }, 
              p: 3, 
              bgcolor: "background.paper", 
              borderLeft: { xs: "none", md: "1px solid #e0e0e0" },
              borderTop: { xs: "1px solid #e0e0e0", md: "none" }
            }}>
              <Card variant="outlined" sx={{ borderRadius: 3 }}>
                <CardContent>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                    Transaction Summary
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: { xs: 2, md: 43 } }}>
                    <Typography color="text.secondary">Unit Price:</Typography>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: "primary.main" }}>
                      ₦{formatWithCommas(unitPrice.toFixed(2))}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography color="text.secondary">Estimated Cost Price:</Typography>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: "primary.main" }}>
                      ₦{formatWithCommas(costPrice.toFixed(2))}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography color="text.secondary">Selling Price:</Typography>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: "secondary.main" }}>
                   ₦{formatWithCommas(toNumber(formData.sellingPrice).toFixed(2))}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography color="text.secondary">Commission:</Typography>
                    <Typography 
                      variant="h5" 
                      sx={{ 
                        fontWeight: 700, 
                        color: commission >= 100 ? "success.main" : "error.main"
                      }}
                    >
                      ₦{formatWithCommas(commission.toFixed(2))}
                      {commission < 100 && (
                        <Typography 
                          variant="body2" 
                          color="error" 
                          sx={{ mt: 0.5 }}
                        >
                          (Minimum ₦100 required)
                        </Typography>
                      )}
                    </Typography>
                  </Box>
                  <Divider sx={{ my: 2 }} />
                  
                  {/* Show specific validation errors */}
{formErrors.length > 0 && (
  <Box sx={{ mb: 2, p: 1, bgcolor: 'warning.light', borderRadius: 1 }}>
    <Typography variant="body2" sx={{ fontWeight: 700, color: 'white' }}>
      Please fix the following:
    </Typography>
    {formErrors.slice(0, 3).map((error, index) => (
      <Typography 
        key={index} 
        variant="body2" 
        sx={{ 
          ml: 1, 
          fontWeight: 600,
          color: 'white' 
        }}
      >
        • {error}
      </Typography>
    ))}
    {formErrors.length > 3 && (
      <Typography 
        variant="body2" 
        sx={{ 
          ml: 1, 
          fontWeight: 600,
          color: 'white' 
        }}
      >
        • and {formErrors.length - 3} more...
      </Typography>
    )}
  </Box>
)}
                  
                  <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    onClick={handleCreateOrder}
                    startIcon={processingOrder ? <CircularProgress size={24} color="inherit" /> : <Receipt />}
                    sx={{ 
                      py: 1.5, 
                      borderRadius: 2, 
                      textTransform: 'none', 
                      fontWeight: 600,
                      opacity: isFormValid ? 1 : 0.6
                    }}
                    disabled={!isFormValid || processingOrder || commission < 100}
                  >
                    {processingOrder ? 'Submitting...' : 'Submit Transaction'}
                  </Button>

                  {(!isFormValid || commission < 100) && (
                    <Typography variant="body2" color="error" sx={{ mt: 2, textAlign: 'center' }}>
                      {commission < 100 ? 
                        "Commission must be at least ₦100 to process transaction" : 
                        "Please fill specific required fields to enable submission"}
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Box>
          </Box>

        <Dialog open={showCustomerDialog} onClose={() => setShowCustomerDialog(false)} maxWidth="sm" fullWidth style={{ zIndex: 2000 }}>
            <DialogTitle>
                Add New Customer
                <IconButton
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                    onClick={() => setShowCustomerDialog(false)}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Full Name(s)"
                            value={newCustomer.firstName}
                            onChange={(e) =>
                                setNewCustomer({
                                    ...newCustomer,
                                    firstName: e.target.value,
                                })
                            }
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Phone Number"
                            value={newCustomer.phone}
                            onChange={(e) =>
                                setNewCustomer({ ...newCustomer, phone: e.target.value })
                            }
                            required
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Email (Optional)"
                            value={newCustomer.altEmail}
                            onChange={(e) =>
                                setNewCustomer({ ...newCustomer, altEmail: e.target.value })
                            }
                        />
                    </Grid>

                       <Grid item xs={12} md={12}>
                        <TextField
                            fullWidth
                            label="Goldenpay App Username (Optional)"
                            value={newCustomer.email}
                            onChange={(e) =>
                                setNewCustomer({ ...newCustomer, email: e.target.value })
                            }
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setShowCustomerDialog(false)}>Cancel</Button>
                <Button
                    variant="contained"
                    onClick={handleAddCustomer}
                    disabled={loading.customers || !newCustomer.firstName || !newCustomer.phone}
                >
                    {loading.customers ? <CircularProgress size={24} /> : "Add Customer"}
                </Button>
            </DialogActions>
        </Dialog>
  <Dialog open={showSummaryDialog} onClose={() => setShowSummaryDialog(false)} maxWidth="md" fullWidth style={{ zIndex: 2000 }}>
    <DialogTitle sx={{ background: '#1976d2', color: 'white', py: 2, textAlign: 'center' }}>
        <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
            <ReceiptIcon />
            <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>Review Transaction Details</Typography>
        </Box>
    </DialogTitle>
    <DialogContent dividers sx={{ p: 3 }}>
        <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>Customer & Card</Typography>
                <Paper variant="outlined" sx={{ p: 2 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}><ListItemText primary="Customer Name" secondary={formData.customerName || 'N/A'} /></Grid>
                        <Grid item xs={12} sm={6}><ListItemText primary="Phone Number" secondary={formData.customerPhone || 'N/A'} /></Grid>
                        <Grid item xs={12} sm={6}><ListItemText primary="Bank Name" secondary={banks.find(b => b.code === formData.customer_bank_code)?.name || 'N/A'} /></Grid>
                        <Grid item xs={12} sm={6}><ListItemText primary="Account Number" secondary={formData.customer_account_number || 'N/A'} /></Grid>
                        <Grid item xs={12} sm={6}><ListItemText primary="Account Name" secondary={formData.customer_account_name || 'N/A'} /></Grid>
                        <Grid item xs={12} sm={6}><ListItemText primary="Gift Card Type" secondary={(formData.giftcardType)} /></Grid>
                        <Grid item xs={12}><ListItemText primary="Card Code" secondary={formData.cardCode || 'N/A'} /></Grid>
                        <Grid item xs={12} sm={6}><ListItemText primary="Transaction Start Time" secondary={transactionStartTime?.toLocaleString() || 'N/A'} /></Grid>
                        <Grid item xs={12} sm={6}><ListItemText primary="Card Amount" secondary={formData.cardAmount} /></Grid>
                        <Grid item xs={12} sm={6}><ListItemText primary="Card Unit" secondary={formData.cardUnit} /></Grid>
                        <Grid item xs={12} sm={6}><ListItemText primary="Total Card Value" secondary={cardValue.toFixed(2)} /></Grid>
                        <Grid item xs={12} sm={6}><ListItemText primary="Unit Price" secondary={`₦${formatWithCommas(unitPrice.toFixed(2))}`} /></Grid>
                        <Grid item xs={12} sm={6}><ListItemText primary="Load Type" secondary={formData.loadType} /></Grid>


                        {formData.processorType !== 'INTERNAL' && (

                        <Grid item xs={12} sm={6}><ListItemText primary="Card Rate" secondary={formData.cardRate} /></Grid>
                        )}

                        {/* Conditionally show RMB Value only for CHINESE processors */}
                        {formData.processorType === 'EXTERNAL' && processorType === "CHINESE" && (
                            <Grid item xs={12} sm={6}><ListItemText primary="RMB Value" secondary={rmbValue.toFixed(2)} /></Grid>
                        )}
                    </Grid>
                </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>Processor & Rates</Typography>
                <Paper variant="outlined" sx={{ p: 2 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}><ListItemText primary="Processor" secondary={<Chip label={formData.processorType} size="small" color={formData.processorType === 'INTERNAL' ? 'primary' : 'secondary'} />} /></Grid>
                        {formData.processorType === 'EXTERNAL' && (
                            <>
                                <Grid item xs={12} sm={6}><ListItemText primary="External Processor" secondary={formData.externalProcessor} /></Grid>
                                <Grid item xs={12} sm={6}><ListItemText primary="Processor Category" secondary={<Chip label={processorType} size="small" color={processorType === 'USD' ? 'primary' : 'secondary'} />} /></Grid>
                            </>
                        )}
                    {formData.processorType === 'EXTERNAL' && processorType === 'CHINESE' && (
  <>
    <Grid item xs={12} sm={6}>
      <ListItemText
        primary="Naira Rate"
        secondary={
          <Chip
            label={`₦${formatWithCommas(Number(formData.nairaRate).toFixed(2))}`}
            size="small"
            color={processorType === 'USD' ? 'primary' : 'secondary'}
          />
        }
      />
    </Grid>
  </>
)}


                        {formData.processorType === 'INTERNAL' && (
                            <Grid item xs={12} sm={6}><ListItemText primary="Internal Rate" secondary={formData.internalRate} /></Grid>
                        )}
                    </Grid>
                </Paper>
                
                {/* File Previews Section */}
                <Box sx={{ mt: 2 }}>
                    {uploadedFile && (
                        <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
                            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                                <AttachFileIcon fontSize="small" />
                                Evidence of Manual Payments (Optional)
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                                <Typography variant="body2" sx={{ flex: 1 }}>
                                    {uploadedFile.name}
                                </Typography>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    startIcon={<Visibility />}
                                    onClick={() => window.open(URL.createObjectURL(uploadedFile), '_blank')}
                                >
                                    View
                                </Button>
                            </Box>
                        </Paper>
                    )}
                    
                    {jobStatsFile && (
                        <Paper variant="outlined" sx={{ p: 2 }}>
                            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Description fontSize="small" />
                                Evidence of Job Starts *
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                                <Typography variant="body2" sx={{ flex: 1 }}>
                                    {jobStatsFile.name}
                                </Typography>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    startIcon={<Visibility />}
                                    onClick={() => window.open(URL.createObjectURL(jobStatsFile), '_blank')}
                                >
                                    View
                                </Button>
                            </Box>
                        </Paper>
                    )}
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>Financial Summary</Typography>
                 <Box sx={{ display: 'flex', flexDirection: {xs: 'column', sm: 'row'}, gap: 2 }}>
                    <Paper elevation={2} sx={{ flex: 1, p: 2, borderRadius: 2, textAlign: 'center', bgcolor: 'error.50' }}>
                        <Typography variant="button" display="block" sx={{ color: 'error.dark' }}>Cost Price</Typography>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'error.dark' }}>₦{formatWithCommas(costPrice.toFixed(2))}</Typography>
                    </Paper>
                    <Paper elevation={2} sx={{ flex: 1, p: 2, borderRadius: 2, textAlign: 'center', bgcolor: 'success.50' }}>
                        <Typography variant="button" display="block" sx={{ color: 'success.dark' }}>Selling Price</Typography>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'success.dark' }}>₦{formatWithCommas(formData.sellingPrice)}</Typography>
                    </Paper>
                    <Paper elevation={2} sx={{ flex: 1, p: 2, borderRadius: 2, textAlign: 'center', bgcolor: commission >= 100 ? 'info.50' : 'warning.50' }}>
                        <Typography variant="button" display="block" sx={{ color: commission >= 100 ? 'info.dark' : 'warning.dark' }}>Commission</Typography>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: commission >= 100 ? 'info.dark' : 'warning.dark' }}>
                            ₦{formatWithCommas(commission.toFixed(2))}
                            {commission < 100 && (
                                <Typography variant="body2" color="error" sx={{ mt: 0.5 }}>
                                    (Minimum ₦100 required)
                                </Typography>
                            )}
                        </Typography>
                    </Paper>
                </Box>
            </Grid>
        </Grid>
    </DialogContent>
    <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button onClick={() => setShowSummaryDialog(false)} variant="outlined" startIcon={<CancelIcon />}>Cancel</Button>
        <Button 
            onClick={() => { setShowSummaryDialog(false); setShowConfirmDialog(true); }} 
            variant="contained" 
            startIcon={<CheckCircleIcon />} 
            disabled={!isFormValid || commission < 100}
        >
            Continue
        </Button>
    </DialogActions>
</Dialog>
        <Dialog open={showConfirmDialog} onClose={() => setShowConfirmDialog(false)} maxWidth="xs" fullWidth style={{ zIndex: 2000 }}>
            <DialogTitle>Are you sure?</DialogTitle>
            <DialogContent>
                <Typography>Are you sure all values are correct? This action cannot be undone.</Typography>
                <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold' }}>
                    Processor Type Category: {getSelectedProcessorType()}
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                    Gift Card Type: {( formData.giftcardType)}
                </Typography>
                <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic' }}>
                    Job Starts File: {jobStatsFile ? 'Uploaded' : 'Not Uploaded'}
                </Typography>
                <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                    Manual Payments File: {uploadedFile ? 'Uploaded (Optional)' : 'Not Uploaded'}
                </Typography>
                <Typography 
                    variant="body2" 
                    sx={{ mt: 1, fontWeight: 'bold', color: commission < 100 ? 'error.main' : 'success.main' }}
                >
                    Commission: ₦{formatWithCommas(commission.toFixed(2))} 
                    {commission < 100 && " (Minimum ₦100 required)"}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setShowConfirmDialog(false)}>No, go back</Button>
                <Button 
                    onClick={executeCreateOrder} 
                    variant="contained" 
                    color="primary" 
                    disabled={processingOrder || commission < 100}
                >
                    {processingOrder ? <CircularProgress size={24} /> : "Yes, create order"}
                </Button>
            </DialogActions>
        </Dialog>

          <Snackbar
            open={snackbarOpen}
            autoHideDuration={6000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: "100%" }}>
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </IonContent>
      </IonPage>
    );
    
  };
  
  
  export default PosPage_Gift_card;
